import React, { Component } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class ProductRelated extends Component {
	render () {
		const slides = this.props.item.related.map((related,i) =>
			<SwiperSlide key={i}>
				<div>
					<Link to={{ pathname: '/product/' + related.slug + '#to-top'}}>
						<FadeIn duration={250}>
							{onload => (
								<img
									alt={related.alt} 
									src={related.src} 
									srcSet={related.srcset} 
									onLoad={onload}
								/>
							)}
						</FadeIn>
						<h4>{ related.heading }</h4>
					</Link>
				</div>
			</SwiperSlide>
		);
		return (
			<div className="scope-swiper">
				<Swiper
				spaceBetween={0}
				slidesPerView={1.25}
				breakpoints={{
					480: {
						slidesPerView: 2.25,
					},
					768: {
						slidesPerView: 3.25,
					},
					960: {
						slidesPerView: 4,
					}
				}}
				>
					{ slides }
				</Swiper>
			</div>
		);
	}
}